document.addEventListener("DOMContentLoaded", e => {
  const isCart = window.location.pathname === '/cart';
  if(isCart) {
    handleNTCartPage();
  } else {
      renderNetTermButton();
  }
  
    document.addEventListener("on:line-item:change", e => {
        renderNetTermButton();
    })

  const cartDrawer =  document.querySelector("#cart-drawer");
  if(cartDrawer) {
    cartDrawer.addEventListener("on:cart-drawer:after-open", e => {
          renderNetTermButton();
      })
  }
})


function handleNTCartPage(){
    const btnCheckout = document.querySelector(`[name="checkout"]`);
    const ntButton = document.querySelector("section #bss-b2b-net-term-button-wrapper:has(button#bss-b2b-net-term-button)");
    btnCheckout.insertAdjacentElement("afterend", ntButton)
}

function renderNetTermButton() {
    const btnNT = document.querySelector(`cart-drawer #bss-b2b-net-term-button-wrapper`);
    if (btnNT) return;
  
    const btnCheckout = document.querySelector(`[name="checkout"]`);
    if (!btnCheckout) return;
    const ntButton = document.querySelectorAll(".shopify-section-group-footer-group #bss-b2b-net-term-button")
      if(ntButton.length === 1 && ntButton[0].innerText === 'Pay later') return;
    const ntButtonEl = document.querySelector("section #bss-b2b-net-term-button");
  if (!ntButtonEl) return
    const ntText = ntButtonEl.innerText;
    const html = `
        <div id="bss-b2b-net-term-button-wrapper">
            <button onclick="handleNetTermClick()">${ntText}</button>
        </div>
    `;
    btnCheckout.insertAdjacentHTML("afterend", html);
}

function handleNetTermClick() {
    const ntButtonPrimary = document.querySelector("section #bss-b2b-net-term-button-wrapper button");
    if (ntButtonPrimary) ntButtonPrimary.click();
}



const ADDRESS_INPUT_MAP = new Map([
    ["first_name", "first-name"],
    ["last_name", "last-name"],
    ["address1", "address-field"],
    ["address2", "apartment-field"],
    ["city", "city-field"],
    ["zip", "zip-field"],
    ["country_code", "country-field"],
    ["country_name", "country-name"],
    ["company", "company-field"],
    ["phone", "text-field-3dc5499d4f592"],
    ["company", "text-field-06c3dd86219f0"],
    ["commentaire", "text-field-ecdb659eed887"],
]);

function watchB2BAddressSelect() {
    const findSelect = setInterval(() => {
        const select = document.querySelector('#b2b-nt-address-select');
        if (!select) return;
      
        const options = Array.from(select.querySelectorAll('option'));
        const hasNew = options.some(opt => opt.value === 'new');
        const otherOptions = options.filter(opt => opt.value !== 'new');
        if (hasNew && otherOptions.length > 0) {
          const { customer } = window.BSS_B2B?.shopData;
          const options = [];
      
          customer?.addresses?.forEach((item) => {
              const address = [item.address1, item.country].filter(Boolean).join(" ");
              const name = [item.first_name, item.last_name].filter(Boolean).join(" ");
              options.push({ id: item.id, label: `${address} (${name})` });
          });
          select.addEventListener('change', (e) => {
             [...ADDRESS_INPUT_MAP.keys()].forEach((key) => {
                  const inputId = ADDRESS_INPUT_MAP.get(key);
                  const input = document.querySelector(`#b2b-nt-address-info #${inputId}`) || document.querySelector(`.b2b-nt-addition-info #${inputId}`);
                  if (input) {
                      input.value = "";
                      input.dispatchEvent(new Event("change", { bubbles: true }));
                  }
              });
              const selectedValue = e.target.value;
              const address = customer?.addresses?.find(addr => addr.id === Number(selectedValue));
              if (address) {
                  [...ADDRESS_INPUT_MAP.keys()].forEach((key) => {
                      const inputId = ADDRESS_INPUT_MAP.get(key);
                      const input = document.querySelector(`#b2b-nt-address-info #${inputId}`) || document.querySelector(`.b2b-nt-addition-info #${inputId}`);
                      if (input) {
                          if(key === 'commentaire' && BSS_B2B.shopData.customer.tags.includes('comment')) {
                            input.value = 'Commande Terre de Running'
                            input.setAttribute('readonly', true);
                          }
                          else input.value = address[key] || "";
                          input.dispatchEvent(new Event("change", { bubbles: true }));
                      }
                  });
              }
          });
          
          if (select.value === 'new') {
                select.value = otherOptions[0].value;
                select.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
        clearInterval(findSelect);
    }, 100);

    setTimeout(()=> {
      clearInterval(findSelect);
    },3000)
  
}

const findButtonInterval = setInterval(() => {
    const ntBtn = document.querySelector('#bss-b2b-net-term-button');
  if (ntBtn) {
    ntBtn.addEventListener('click', () => {
          watchB2BAddressSelect();
    });
    clearInterval(findButtonInterval);
  }
}, 200);

setTimeout(()=> {
  clearInterval(findButtonInterval);
},3000)